<script>
import { authComputed } from '@state/helpers'
import { isProd } from '@utils/environment'
import NavBarRoutes from './nav-bar-routes.vue'
import NavBarRoutesSub from './nav-bar-routes-sub.vue'

export default {
  components: { NavBarRoutes, NavBarRoutesSub },
  data() {
    return {
      rootSubmenuKeys: ['ma-research', 'admin'],
      openKeys: ['ma-research', 'admin'],
      persistentNavRoutes: [
        {
          name: 'figments',
          title: 'Figments',
          iconType: 'solution',
          admin: false,
        },
      ],
      adminRoutes: [
        {
          name: 'user-management',
          title: 'Users',
          iconType: 'team',
          admin: true,
        },
        {
          name: 'sim-management',
          title: 'SIMs',
          iconType: 'phone',
          admin: true,
        },
        {
          name: 'container-management',
          title: 'Containers',
          iconType: 'code',
          admin: true,
        },
      ],
      maResearchRoutes: [
        // {
        //   name: 'research-md-1',
        //   title: 'Accokeek, MD',
        //   iconType: 'radar-chart',
        //   admin: false,
        //   prod: true,
        // },
        // {
        //   name: 'research-ca-1',
        //   title: `Los Angeles, CA`,
        //   iconType: 'radar-chart',
        //   admin: false,
        //   prod: true,
        // },
        // {
        //   name: 'research-va-1',
        //   title: 'Chantilly, VA',
        //   iconType: 'radar-chart',
        //   admin: false,
        //   prod: true,
        // },
        {
          name: 'research-la-1',
          title: 'New Orleans, LA',
          iconType: 'radar-chart',
          admin: true,
          prod: true,
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'support',
          title: 'Support',
          iconType: 'api',
          admin: false,
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    // super admin
    if (
      this.$auth.user.profile.permissions.organization === 'vanished' &&
      this.$auth.user.profile.permissions.role === 'admin'
    ) {
      this.maResearchRoutes = this.maResearchRoutes.filter((route) => {
        if (isProd()) {
          return route.prod
        } else {
          return route.prod
        }
      })
      return null
    }

    if (this.$auth.user.profile.permissions.role !== 'admin') {
      this.adminRoutes = this.adminRoutes.filter(
        (route) => route.admin !== true
      )
      this.adminRoutes = this.adminRoutes.filter((route) =>
        this.$auth.user.profile.permissions.features.includes(route.name)
      )

      this.maResearchRoutes = this.maResearchRoutes.filter(
        (route) => route.admin !== true
      )
      this.maResearchRoutes = this.maResearchRoutes.filter((route) =>
        this.$auth.user.profile.permissions.features.includes(route.name)
      )

      this.persistentNavRoutes = this.persistentNavRoutes.filter(
        (route) => route.admin !== true
      )
      this.persistentNavRoutes = this.persistentNavRoutes.filter((route) =>
        this.$auth.user.profile.permissions.features.includes(route.name)
      )
    } else {
      this.adminRoutes = this.adminRoutes.filter((route) =>
        this.$auth.user.org.permissions.features.includes(route.name)
      )
      this.persistentNavRoutes = this.persistentNavRoutes.filter((route) =>
        this.$auth.user.org.permissions.features.includes(route.name)
      )
    }

    this.maResearchRoutes = this.maResearchRoutes.filter((route) => {
      if (isProd()) {
        return route.prod
      } else {
        return !route.prod
      }
    })
  },
  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      )
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.logo">
      <router-link to="/" exact>
        <img
          src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-w-2.png"
          alt="logo"
        />
      </router-link>
    </div>
    <a-menu
      :class="$style.menu"
      theme="dark"
      mode="inline"
      :open-keys="openKeys"
      @openChange="onOpenChange"
    >
      <a-sub-menu v-if="adminRoutes.length" key="admin">
        <span slot="title"><a-icon type="setting" /><span>Admin</span></span>
        <NavBarRoutesSub :routes="adminRoutes" />
      </a-sub-menu>

      <a-sub-menu key="ma-research">
        <span slot="title"
          ><a-icon type="radar-chart" /><span>MA Research</span></span
        >
        <NavBarRoutesSub :routes="maResearchRoutes" />
      </a-sub-menu>

      <NavBarRoutes :routes="persistentNavRoutes" />

      <NavBarRoutes :routes="loggedOutNavRoutes" />
    </a-menu>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.logo {
  width: 100%;
  padding: $size-grid-padding;
  margin-bottom: $size-grid-padding;
  text-align: center;
  border-width: 3px;
  border-bottom: 3px solid white;
  border-image-source: linear-gradient(to left, #fafafa, #8c8c8c);
  border-image-slice: 1;

  img {
    width: 95%;
  }
}

.container {
  padding: 0;
  margin: 0 0 $size-grid-padding;
  text-align: center;
  list-style-type: none;

  > li {
    display: inline-block;
    margin-right: $size-grid-padding;
  }
}
</style>
